import { IProperty } from "../interfaces/property/property.model.interface";
import { IState } from "../interfaces/config/state.model.interface";
import { IPublisher } from "../interfaces/publisher/publisher.model.interface";
import { State } from "../config/state.model";

export class Publisher implements IPublisher {
    public publisherId: number;
    public name: string;
    public state: IState;
    public properties: IProperty[];

    constructor() {
        this.publisherId = 0;
        this.name = "";
        this.state = new State();
        this.properties = [];
    }
}
